module.exports = __webpack_public_path__ + "static/media/success-check-icon.138ee05c.svg";